/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAlignCenter: {
  name: 'align-center';
  data: string;
} = {
  name: 'align-center',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 1.5a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1H1Zm0 12a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1H1ZM3.5 6a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5ZM4 9.5a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1H4Z" fill="currentColor"/></svg>`,
};
